import { useState, useEffect } from "react";
import {
  addDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  limit,
  onSnapshot,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import { getSubCollection } from "../utils/getSubCollection";
import OrdenForm from "../components/OrdenForm";
import TablaOrdenes from "../components/TablaOrdenes";
import PreviaOrden from "../components/PreviaOrden";

function NuevaOrden({ mostrarBotonNuevo }) {
  const { user, teamOwnerId } = useAuth();
  const ownerUid = teamOwnerId || user.uid;
  const [ordenes, setOrdenes] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [numeroOrden, setNumeroOrden] = useState(1);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [mostrarPrevia, setMostrarPrevia] = useState(false);
  const [ordenSeleccionada, setOrdenSeleccionada] = useState(null);

  useEffect(() => {
    // 1) Cargar proveedores desde subcolección del usuario
    const provCol = getSubCollection(ownerUid, "proveedores");
    getDocs(provCol).then((snap) =>
      setProveedores(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );

    // 2) Sacar siguiente número de orden
    const ordCol = getSubCollection(ownerUid, "ordenes");
    const qNum = query(ordCol, orderBy("numeroOrden", "desc"), limit(1));
    getDocs(qNum).then((snap) => {
      if (!snap.empty) {
        const max = snap.docs[0].data().numeroOrden || 0;
        setNumeroOrden(max + 1);
      }
    });

    // 3) Suscribirse en tiempo real a ordenes
    const unsubscribe = onSnapshot(ordCol, (snap) => {
      setOrdenes(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsubscribe();
  }, [ownerUid]);

  const activarFormulario = () => {
    setOrdenSeleccionada(null);
    setMostrarFormulario(true);
  };

  const guardarOrden = async (ordenData, modoEdicion, ordenId) => {
    const ordCol = getSubCollection(ownerUid, "ordenes");
    if (modoEdicion && ordenId) {
      // — Actualizar existente —
      const ref = doc(ordCol, ordenId);
      await updateDoc(ref, ordenData);
    } else {
      // — Crear nuevo —
      await addDoc(ordCol, {
        ...ordenData,
        ownerId: ownerUid,
        numeroOrden,
        createdAt: serverTimestamp(),
        estado: "Pendiente",
      });
      setNumeroOrden((n) => n + 1);
    }
    setMostrarFormulario(false);
  };

  const verPrevia = (o) => {
    setOrdenSeleccionada(o);
    setMostrarPrevia(true);
  };

  return (
    <div>
      {!mostrarFormulario && mostrarBotonNuevo && (
        <button className="action-button2" onClick={activarFormulario}>
          + Nuevo
        </button>
      )}

      {mostrarFormulario ? (
        <OrdenForm
          orden={ordenSeleccionada}
          proveedores={proveedores}
          guardarOrden={guardarOrden}
          numeroOrden={numeroOrden}
        />
      ) : mostrarPrevia ? (
        <PreviaOrden
          orden={ordenSeleccionada}
          proveedores={proveedores}
          numeroOrden={ordenSeleccionada?.numeroOrden}
          cerrarPrevia={() => setMostrarPrevia(false)}
          guardarOrden={guardarOrden}
        />
      ) : (
        <TablaOrdenes
          ordenes={ordenes}
          proveedores={proveedores}
          numeroOrden={numeroOrden}
          verPrevia={verPrevia}
          guardarOrden={guardarOrden}
          setOrdenes={setOrdenes}
        />
      )}
    </div>
  );
}

export default NuevaOrden;
